import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  containerCampos: {
    paddingBottom: theme.spacing(3),
  },

  field: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  formGroup: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
